import { TextSubtext } from '@porterin/feature/src/shared/types/CommonVM';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React from 'react';

import styles from '../styles/FareEstimateError.module.scss';
import { NextImageContent } from '../view-model/FareEstimateVm';

interface FareEstimateErrorCmpProps {
  image: NextImageContent;
  content: TextSubtext;
  button_text: string;
  button_action: () => void;
  align_text_left?: boolean;
}

function FareEstimateErrorCmp({
  image,
  content,
  button_text,
  button_action,
  align_text_left = true,
}: Readonly<FareEstimateErrorCmpProps>): React.ReactElement {
  return (
    <div className={styles['container-error']}>
      <div className={styles['content']}>
        <div className={styles['icon']}>
          <NextImageV2
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
          />
        </div>
        <div
          className={
            align_text_left
              ? styles['text-wrapper-left']
              : styles['text-wrapper']
          }
        >
          <p className={styles['title']}>{content.text}</p>
          <p className={styles['subtitle']}>{content.sub_text}</p>
        </div>
        <button className={styles['retry-button']} onClick={button_action}>
          {button_text}
        </button>
      </div>
    </div>
  );
}

export default FareEstimateErrorCmp;
